import type { CardThumbnailBadge } from "../Card";

type BadgeGame = {
  isNew?: boolean | null;
  isHot?: boolean | null;
  isTrending?: boolean | null;
  isHighRoller?: boolean | null;
};

const GRADIENTS = {
  trending: "linear-gradient(254deg, #FF8911 -11.86%, #E74A13 111.41%)",
  new: "linear-gradient(254deg, #8A1DFF -11.86%, #6100E2 111.41%)",
  "high-roller": "linear-gradient(257deg, #4B0773 0%, #FF003C 100%)",
};

export const BADGE_TRANSLATION_KEYS = [
  "game.label_trending",
  "game.label_hot",
  "game.label_new",
  "game.label_high-roller",
] as const;

const computeBadge = (
  game: BadgeGame,
  translations?: Record<string, string>,
): CardThumbnailBadge | null => {
  const t = (key: string, fallback: string) => translations?.[key] ?? fallback;

  if (game.isTrending)
    return {
      label: t("game.label_trending", "Trending"),
      color: "bg-destructive",
      gradient: GRADIENTS.trending,
    };
  if (game.isHot)
    return { label: t("game.label_hot", "Hot"), color: "bg-black" };
  if (game.isNew)
    return {
      label: t("game.label_new", "New"),
      color: "bg-positive",
      gradient: GRADIENTS.new,
    };
  if (game.isHighRoller)
    return {
      label: t("game.label_high-roller", "High Roller"),
      color: "bg-black",
      gradient: GRADIENTS["high-roller"],
    };
  return null;
};

export default computeBadge;
